import { render, staticRenderFns } from "./PlatformLogin.vue?vue&type=template&id=0b27316e&scoped=true&"
import script from "./PlatformLogin.vue?vue&type=script&lang=js&"
export * from "./PlatformLogin.vue?vue&type=script&lang=js&"
import style0 from "./PlatformLogin.vue?vue&type=style&index=0&id=0b27316e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b27316e",
  null
  
)

export default component.exports